import { render } from "./ArticlesView.vue?vue&type=template&id=166a12f8&scoped=true"
import script from "./ArticlesView.vue?vue&type=script&lang=js"
export * from "./ArticlesView.vue?vue&type=script&lang=js"

import "./ArticlesView.vue?vue&type=style&index=0&id=166a12f8&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-166a12f8"]])

export default __exports__